// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1PPks","inner":"Footer_inner__2hs-R"};